/* eslint-disable no-console */
import { i18n } from '@/services/i18n/i18n.js'

export default {
    namespaced: true,
    state: {
        language: 'en'
      },
      getters: {},
      mutations: {
          SET_LANG (state, lang) {
              i18n.locale = lang
          }      
      }
}
